import { DATE_FORMAT } from '@yarmill/const';
import { SeasonStore } from '@yarmill/types';
import moment from 'moment';

export function getLastSeasonEnd(seasons: SeasonStore[]) {
  return moment
    .max(seasons.map((season: SeasonStore) => moment(season.endDate)))
    .format(DATE_FORMAT);
}
